/*** IMPORTS FROM imports-loader ***/
var loadTerrific = require("bootstrap/load-terrific");
var Tc = loadTerrific.default;
(function() {
var window = this;
var window = (window || {});
window.Tc = Tc;

(function ($, w) {
	/*
	 * Dependencies:
	 * TerrificJs 2.0.1,
	 * jQuery 1.7 or greater,
	 */

	'use strict';
	/*globals Tc */

	/**
	 * @Deprecated
	 *
	 * @author Yves De Bruyne
	 * @namespace Tc.Module
	 * @class C4PrintButton
	 * @extends Tc.Module
	 */
	Tc.Module.C4PrintButton = Tc.Module.extend({

		SERVLET_PATH: "/etc/swisscom/servlets/public/c4export.json",
		$link: null,
		$form: null,
		$randomToken: null,
		mappings: null,


		/**
		 * Hook function to do all of your module stuff.
		 *
		 * @method on
		 * @param {Function} callback function
		 * @return void
		 */
		on: function (callback) {
			var mod = this;

			mod.$link = mod.$ctx.find('a');
			mod.$form = mod.$ctx.closest('form');
			mod.mappings = mod.$link.data('mappings');
			
			mod.$randomToken = mod.$form.find('input[name="randomGeneratedToken"]');
			mod.$randomToken.val(Math.round(Math.random() * 1000000) + '' + new Date().getTime());
			
			if (!$('body').hasClass('cq_isEditMode')) {
				mod.$form.find('.modDownloadNRepPDF').css('visibility', 'hidden');
			}

			mod.$link.click(function () {
				mod.clickAction();
			});

			callback();
		},

		clickAction: function () {
			var mod = this,
				serializedData = mod.$form.serialize(),
				renamedSerializedData = Tc.Module.C4PrintButton.renameKeys(serializedData, mod.mappings);

			if(mod.$ctx.find('input[name="c4ExportType"]').val() == 'number_transfer'){
			
				$.ajax(mod.$form.attr('action'), {							
					type: 'POST',
					data: serializedData,
					dataType: 'json',
					success: $.proxy(mod.formSubmittedSuccess, mod),
					error: $.proxy(mod.formSubmittedError, mod)
				});
				
			} else {
				
				/* send data to C4 */
				$.ajax(mod.SERVLET_PATH, {
					success: $.proxy(mod.openC4Popup, mod),
					error: $.proxy(mod.printPage, mod),
					type: 'POST',
					data: renamedSerializedData
				});
				
			}

		},
		
		formSubmittedSuccess: function (data, textStatus, jqXHR) {
			var mod = this, 
				$ctx = mod.$ctx;
			
			if(data.hasOwnProperty('message') && data.message != null){
				mod.fireAjaxError(data.message);
			} else if(data.hasOwnProperty('data') && $.isArray(data.data) && data.data.length > 0) {
				mod.fireHandleError(data);
			} else {
			
				var serializedData = mod.$form.serialize();
				var renamedSerializedData = Tc.Module.C4PrintButton.renameKeys(serializedData, mod.mappings);
			
				/* send data to C4 */
				$.ajax(mod.SERVLET_PATH, {
					success: $.proxy(mod.openC4Popup, mod),
					error: $.proxy(mod.printPage, mod),
					type: 'POST',
					data: renamedSerializedData
				});			
			}
		},
		
		formSubmittedError: function (jqXHR, textStatus, errorThrown) {
			var mod = this, 
				$ctx = mod.$ctx;
				
			mod.fireAjaxError(JSON.parse(jqXHR.responseText).message);
		},
		
		fireAjaxError: function (msg) {
			var mod = this, 
				$ctx = mod.$ctx;

			mod.fire('ajaxError', {message: msg, title: mod.$ctx.data('generalErrorTitle')}, ['wizard']);
		},
		
		fireHandleError: function (data) {
			var mod = this, 
				$ctx = mod.$ctx;

			mod.fire('handleError', data, ['wizard']);
		},		

		openC4Popup: function (data, textStatus, jqXHR) {
			var mod = this, 
				$ctx = mod.$ctx;
				
			console.log('openC4Popup data=', data)
			if(data && data.url){
				var win = window.open(data.url, '_blank');
//				win.focus();
			}else{
				window.print();
			}
			
			if(mod.$ctx.find('input[name="c4ExportType"]').val() == 'number_transfer'){
				if(data && data.url){
					var $currentStep = mod.$ctx.closest('.multipage-wizard-step');
					mod.fire('preloadNextStepAndDisplay',{ stepUrl: mod.$ctx.data('success-page-url'), prevStep: $currentStep.prop('id')}, ['wizard']);
				} else {
					var $currentStep = mod.$ctx.closest('.multipage-wizard-step');
					mod.fire('preloadNextStepAndDisplay',{ stepUrl: mod.$ctx.data('error-page-url'), prevStep: $currentStep.prop('id')}, ['wizard']);
				}
			}
		},

		printPage: function (jqXHR, textStatus, errorThrown) {
			var mod = this, 
				$ctx = mod.$ctx;
			
			if(mod.$ctx.find('input[name="c4ExportType"]').val() == 'number_transfer'){
				var $currentStep = mod.$ctx.closest('.multipage-wizard-step');
				mod.fire('preloadNextStepAndDisplay',{ stepUrl: mod.$ctx.data('error-page-url'), prevStep: $currentStep.prop('id')}, ['wizard']);
			} else {
				window.print();
			}
		}
	});

	Tc.Module.C4PrintButton.renameKeys = function (serializedData, mappings) {

		for (var i = 0; i < mappings.length; i++) {
			var formKey = mappings[i].key,
				servletKey = mappings[i].value;

			var keyRegExp = new RegExp('(\\b|&)' + formKey + '=', 'g');

			serializedData = serializedData.replace(keyRegExp, '$1' + servletKey + '=');
		}

		//neutralize formstart
		serializedData = serializedData.replace(/(\b|&)%3Aformid=/g, '$1_formid=');
		serializedData = serializedData.replace(/(\b|&)%3Aformstart=/g, '$1_formstart=');
		serializedData = serializedData.replace(/(\b|&)%3Aformtype=/g, '$1_formtype=');

		return serializedData;
	}

}(Tc.$, window));
}.call(window));


//////////////////
// WEBPACK FOOTER
// ./clientlibs/js/etc/designs/forms/clientlibs/shared/js/modules/Tc.Module.C4PrintButton.js
// module id = 271
// module chunks = 0